import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations/dist/vue';
import { Integrations } from '@sentry/tracing';

/**
 * Initialize
 */
export const initializeSentry = () => {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    defaultIntegrations: false,
    integrations: [
      new VueIntegration({
        Vue,
        tracing: true,
        logErrors: true,
      }),
      new Integrations.BrowserTracing(),
      // new Integrations.BrowserTracing({
      //   tracingOrigins: [`appdev.alphaus.cloud`, `next.alphaus.cloud`, `app.alphaus.cloud`],
      // }),
    ],
    tracesSampleRate: 1.0,
    release: process.env.VUE_APP_VERSION,
    environment: process.env.VUE_APP_MODE,
    beforeSend(event) {
      if (event.extra) {
        if (event.extra.data) {
          // Don't send extra.data password.
          delete event.extra.data.password;
        }
      }
      return event;
    },
  });

  // Custom tags
  Sentry.setTag('localhost', process.env.NODE_ENV === 'development');
};

/**
 * Reset
 */
export const resetSentry = () => {
  Sentry.configureScope(scope => scope.setUser(null));
};

/**
 * Set user data
 * @param user
 */
export const setUserToSentry = user => {
  Sentry.setUser({
    id: user.username ? user.username : user.msp_id,
    username: user.company_name,
  });

  Sentry.setContext('User Information - GET:USER', user);
};

export const captureAuthorizationError = response => {
  let messages;

  if (response.data.error === 'invalid_credentials') {
    messages = 'Invalid USER NAME or PASS';
  } else {
    messages = response.data;
  }

  const data = {
    extra: {
      messages: messages,
      status: response.status,
      timeout: response.config.timeout,
    },
  };

  Sentry.captureMessage(`Authorization Error`, data);
};

export const captureHttpError = response => {
  // Case: Reason is "Invalid token".
  if (response.data) {
    if (response.data.description === 'Invalid token') return false;
  }

  const data = {
    extra: {
      url: response.config.url,
      messages: response.data,
      status: response.status,
      method: response.config.method,
      timeout: response.config.timeout,
      data: response.config.data,
    },
  };

  // Sub title
  const subtitle = response.config.url;

  Sentry.captureMessage(`[${response.status}]API Error - ${subtitle}`, data);
};

export const captureError = (error, payload = {}) => {
  const data = {
    extra: payload,
  };
  Sentry.captureException(error, data);
};

export const captureMessage = (message, payload = {}) => {
  const data = {
    extra: payload,
  };
  Sentry.captureMessage(message, data);
};

export const addBreadcrumb = (message, category = 'action', level = 'info') => {
  // Level Type
  let levelType;
  switch (level) {
    case 'error':
      levelType = Sentry.Severity.Error;
      break;
    case 'warning':
      levelType = Sentry.Severity.Warning;
      break;
    default:
      levelType = Sentry.Severity.Info;
  }

  Sentry.addBreadcrumb({
    category: category,
    message: message,
    level: levelType,
  });
};
